//#region src/components/HighlightSearch/HighlightSearch.module.css
var e = "_mark_hv0yo_1", t = { mark: e };
//#endregion
export { t as default, e as mark };
